import React, { ReactNode } from "react";
import { cn } from "../../lib/utils";

interface SubPageHeaderProps {
  title: string;
  subtitle: string;
  icon: React.ElementType;
  actions?: ReactNode;
  className?: string;
  iconColor?: string;
  borderColor?: string;
}

export const SubPageHeader: React.FC<SubPageHeaderProps> = ({
  title,
  subtitle,
  icon: Icon,
  actions,
  className,
  iconColor = "text-[#885ABB]",
  borderColor = "border-l-[#885ABB]",
}) => {
  return (
    <div
      className={cn(
        "bg-white rounded-xl shadow-sm border border-gray-200 border-l-4 p-3 sm:p-4 lg:p-6 flex-shrink-0",
        borderColor,
        className
      )}
    >
      <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-3 sm:gap-4">
        <div className="flex items-start gap-2 sm:gap-3 min-w-0">
          <div className={cn(
            "p-1.5 sm:p-2 rounded-lg flex-shrink-0",
            iconColor === "text-[#885ABB]" ? "bg-purple-50" : "bg-gray-50"
          )}>
            <Icon className={cn("h-4 w-4 sm:h-5 sm:w-5 lg:h-6 lg:w-6", iconColor)} />
          </div>
          <div className="min-w-0">
            <h2 className="text-base sm:text-lg lg:text-2xl font-bold text-gray-900 leading-tight truncate">
              {title}
            </h2>
            <p className="text-gray-500 text-[10px] sm:text-xs lg:text-sm mt-0.5 line-clamp-1">{subtitle}</p>
          </div>
        </div>
        {actions && (
          <div className="flex items-center gap-1.5 sm:gap-2 lg:gap-3 w-full sm:w-auto sm:justify-end shrink-0 [&_button]:text-[11px] sm:[&_button]:text-sm [&_button]:h-7 sm:[&_button]:h-9 [&_button]:px-2.5 sm:[&_button]:px-4 [&_button]:gap-1 sm:[&_button]:gap-2 [&_svg]:h-3.5 [&_svg]:w-3.5 sm:[&_svg]:h-4 sm:[&_svg]:w-4">
            {actions}
          </div>
        )}
      </div>
    </div>
  );
};
